export default __webpack_public_path__ + "static/media/btn.11b67a0e.png";